<template>
  <div class="bg-gray-50 dark:bg-gray-800 min-h-screen">
   

    <!-- Process Flow Section -->
    <section class="py-12 bg-white dark:bg-gray-900">
      <div class="container mx-auto px-4">
        <div class="text-center mb-8">
          <h3 class="text-2xl sm:text-3xl font-bold dark:text-white text-gray-800">
            {{ t('about.process_title') }}
          </h3>
          <p class="text-gray-600 dark:text-gray-400 mt-2">
            {{ t('about.process_subtitle') }}
          </p>
        </div>
        <div class="max-w-6xl mx-auto">
          <ProcessFlowChart />
        </div>
      </div>
    </section>

    <!-- Benefits Section -->
    <section class="py-12 bg-gray-50 dark:bg-gray-800">
      <div class="container mx-auto px-4">
        <div class="text-center mb-8">
          <h3 class="text-2xl sm:text-3xl font-bold dark:text-white text-gray-800">
            {{ t('about.benefits_title') }}
          </h3>
          <p class="text-gray-600 dark:text-gray-400 mt-2">
            {{ t('about.benefits_subtitle') }}
          </p>
        </div>
        <div class="max-w-5xl mx-auto">
          <BenefitsChart />
        </div>
      </div>
    </section>

    <!-- Comparison Section -->
    <section class="py-12 bg-white dark:bg-gray-900">
      <div class="container mx-auto px-4">
        <div class="max-w-5xl mx-auto">
          <ComparisonChart />
        </div>
      </div>
    </section>

    <!-- Original Cards Section -->
    <section class="py-16 bg-gray-50 dark:bg-gray-800">
      <div class="container mx-auto px-4">
        <div class="flex flex-wrap justify-center gap-8">
          <div class="w-full sm:w-80 px-4 text-center">
            <div class="bg-white dark:bg-gray-700 rounded-2xl shadow-lg p-6 h-full transition-transform hover:scale-105">
              <div class="text-gray-900 p-3 w-16 h-16 shadow-lg rounded-full bg-gradient-to-br from-orange-400 to-red-500 inline-flex items-center justify-center mb-4">
                <font-awesome-icon class="h-8 w-8 text-white" icon="fa-solid fa-medal" />
              </div>
              <h6 class="text-xl font-bold dark:text-white text-gray-800">{{ t('about.card_1_title') }}</h6>
              <p class="mt-3 text-gray-600 dark:text-gray-300">{{ t('about.card_1_message') }}</p>
            </div>
          </div>
          <div class="w-full sm:w-80 px-4 text-center">
            <div class="bg-white dark:bg-gray-700 rounded-2xl shadow-lg p-6 h-full transition-transform hover:scale-105">
              <div class="text-gray-900 p-3 w-16 h-16 shadow-lg rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 inline-flex items-center justify-center mb-4">
                <font-awesome-icon class="h-8 w-8 text-white" icon="fa-solid fa-square-poll-vertical" />
              </div>
              <h5 class="text-xl font-bold dark:text-white text-gray-800">{{ t('about.card_2_title') }}</h5>
              <p class="mt-3 text-gray-600 dark:text-gray-300">{{ t('about.card_2_message') }}</p>
            </div>
          </div>
          <div class="w-full sm:w-80 px-4 text-center">
            <div class="bg-white dark:bg-gray-700 rounded-2xl shadow-lg p-6 h-full transition-transform hover:scale-105">
              <div class="text-gray-900 p-3 w-16 h-16 shadow-lg rounded-full bg-gradient-to-br from-blue-400 to-cyan-500 inline-flex items-center justify-center mb-4">
                <font-awesome-icon class="h-8 w-8 text-white" icon="fa-solid fa-lightbulb" />
              </div>
              <h5 class="text-xl font-bold dark:text-white text-gray-800">{{ t('about.card_3_title') }}</h5>
              <p class="mt-3 text-gray-600 dark:text-gray-300">{{ t('about.card_3_message') }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

     <!-- Hero Section -->
    <section class="py-12 bg-white dark:bg-gray-900">
      <div class="container mx-auto px-4 lg:pt-16">
        <div class="flex flex-wrap text-center justify-center">
          <div class="w-full lg:w-10/12 px-4">
            <h2 class="text-3xl sm:text-4xl font-bold dark:text-white text-gray-800">
              {{ t('about.title') }}
            </h2>
            <p class="text-base sm:text-lg leading-relaxed text-justify mt-6 mb-4 text-gray-600 dark:text-gray-300 max-w-4xl mx-auto">
              {{ t('about.message') }}
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import ProcessFlowChart from '../components/charts/ProcessFlowChart.vue';
import BenefitsChart from '../components/charts/BenefitsChart.vue';
import ComparisonChart from '../components/charts/ComparisonChart.vue';

const { t } = useI18n();
</script>

<style scoped>
</style>
